<template>
    <back-button :route="{ name: 'products' }"/>
    <div class="flex flex-col my-3">
        <user-heading
            v-if="storeProduct"
            :user="storeProduct.user"
        ></user-heading>

        <activity-logs-modal
            :resource="resourceToShow"
            @resetResource="resourceToShow = null;"
        />

        <nav-tabs :exact="false" :tabs="tabs" class="mb-5" />

        <div class="grid grid-cols-6 gap-4">
            <div class="col-span-6">
                <product-interactions
                    :product="storeProduct"
                    :showCard="true"
                    :showInteractions="true"
                    @fetch="fetchProduct(storeProduct.id)"
                />
            </div>
        </div>
    </div>
</template>

<script>
import BackButton from "../../../components/layouts/navigation/BackButton.vue";
import NavTabs from "../../../components/layouts/NavTabs.vue";
import Filters from "../../../components/layouts/Filters.vue";
import TableComponent from "../../../components/layouts/table/TableComponent.vue";
import { mapActions, mapWritableState } from "pinia";
import ActivityLogsModal from "../modals/ActivityLogsModal.vue";
import { Store } from "../../../stores/store.js";
import TictoLoading from "../../../components/layouts/TictoLoading.vue";
import UserHeading from "../../users/UserHeading.vue";
import Navigation from "../../../components/layouts/navigation/vertical/Navigation.vue";
import ProductInteractions from "../../../components/product/ProductInteractions.vue";
import {
    BookOpenIcon,
    RectangleStackIcon,
    VideoCameraIcon,
} from "@heroicons/vue/24/outline";

export default {
    name: "ProductMembersContents",
    components: {
        BackButton,
        NavTabs,
        UserHeading,
        Filters,
        ActivityLogsModal,
        TictoLoading,
        Navigation,
        TableComponent,
        ProductInteractions
    },
    data() {
        return {
            tabs: [
                {
                    name: "details",
                    label: "Detalhes",
                    route: "product",
                    params: { product_id: this.$route.params.product_id },
                },
                {
                    name: "interactions",
                    label: "Interações",
                    route: "product.interactions",
                    params: { product_id: this.$route.params.product_id },
                },
                {
                    name: "students",
                    label: "Alunos",
                    route: "product.students",
                    params: { product_id: this.$route.params.product_id },
                },
                {
                    name: "members",
                    label: "Area de membros",
                    route: "product.members",
                    params: { product_id: this.$route.params.product_id },
                }
            ],
            loading: false,
            impersonateLoading: false,
            students: [],
            studentToShow: null,
            next_page_url: false,
            selected: [],
            all_selected: false,
            pagination: {
                total: 0,
                per_page: 10,
                current_page: 1,
                last_page: 11,
                from: 1,
                to: 11,
            },
            filters: {
                text: "",
                types: [],
                date: [],
            },
            resourceToShow: null,
        }
    },
    computed: {
        ...mapWritableState(Store, ["storeProduct", "permissions"]),
        headers() {
            return [
                "Nome",
                "Ações",
            ];
        },
    },
    methods: {
        ...mapActions(Store, ["fetchProduct"]),
    },
    mounted() {
        this.fetchProduct(this.$route.params.product_id);

    }
}
</script>
